import { useDispatch, useSelector } from "react-redux";
import { useAppStore } from "../../zustand/useAppStore";

export const ActionButton = ({ item, setDropDown }) => {
  const { 
    Get, Post, Update, Delete, showModal, setShowModal, 
    setComponentLoading, setFormSelectsLoading } = useAppStore();

  const selectData = useSelector((state) => state.cart.selectData);
  const dispatch = useDispatch();

  /* =========================================
     🌟 REDUX DISPATCH HELPER FUNCTIONS
     ========================================= */
  const setModalFetchedData = (payload) => dispatch({ type: 'cart/setModalFetchedData', payload });
  const setModalData = (payload) => dispatch({ type: 'cart/setModalData', payload });
  const setModalCustomData = (payload) => dispatch({ type: 'cart/setModalCustomData', payload });
  const setSelectData = (payload) => dispatch({ type: 'cart/setSelectData', payload });


  async function fetchModalMainData() {
    try {
      const recordData_ = item.components.filter((item) => item.type === 'list' || item.type === 'table');
      var Json = {};

      for (var i = 0; i < recordData_.length; i++) {
        if (recordData_[i].api === 'static') {
          var StaticData = [];
          if (recordData_[i].details && recordData_[i].details?.data) {
            StaticData = recordData_[i].details.data;
          }
          Json = { ...Json, [`TL_${recordData_[i].comp_id}`]: StaticData };
        } else {
          try {
            setComponentLoading({ compId: recordData_[i].comp_id, value: true });
            var res = await Get('', recordData_[i].api, `limit=${Number(recordData_[i].details.limit)}&${recordData_[i].details.apiData} `);
            if (res.success) {
              Json = { ...Json, [`TL_${recordData_[i].comp_id}`]: res.data };
            }
          } catch (error) {
            console.log('Error in fetchModalMainData: ', error);
          } finally {
            setComponentLoading({ compId: recordData_[i].comp_id, value: false });
          }
        }
      }

      setModalFetchedData(Json);
    } catch (error) {
      console.log('Error in fetchModalMainData: ', error);
    }
  }

  async function fetchFormSelectsData() {
    try {
      let SelectJson = selectData;
      const FormData = item.components.filter((item) => item.type === 'form');
      
      if (FormData.length > 0) {
        for (var i = 0; i < FormData.length; i++) {
          const formData = FormData[i].details.data;
          const formData_ = formData.filter(item => item.options);

          for (var j = 0; j < formData_.length; j++) {
            if (formData_[j].optionsData === 'api') {
              setFormSelectsLoading({ key: `${FormData[i].comp_id}_${formData_[j].id}`, value: true });
            }
          }

          if (formData_.length > 0) {
            for (var j = 0; j < formData_.length; j++) {
              var api_data = '';
              if (formData_[j].apiData) {
                api_data = formData_[j].apiData;
              }

              if (formData_[j].optionsData === 'api') {
                try {
                  const res = await Get('', formData_[j].api, api_data);
                  if (res.success) {
                    SelectJson = { ...SelectJson, [`${FormData[i].comp_id}_${formData_[j].id}`]: res.data };
                  } else {
                    SelectJson = { ...SelectJson, [`${FormData[i].comp_id}_${formData_[j].id}`]: [] };
                  }
                } catch (error) {
                  console.log(`Error in Modal fetchFormSelectsData ${FormData[i].comp_id}_${formData_[j].id} : `, error);
                } finally {
                  setFormSelectsLoading({ key: `${FormData[i].comp_id}_${formData_[j].id}`, value: false });
                }
              } else {
                SelectJson = { ...SelectJson, [`${FormData[i].comp_id}_${formData_[j].id}`]: formData_[j].options };
              }
            }
          }
        }
      }

      setSelectData(SelectJson);
    } catch (error) {
      console.log('Error in fetchFormSelectsData (Modal Section): ', error);
    }
  }

  async function fetchCustomData() {
    var customJson = {};
    try {
      const CustomData = item.components.filter((item) => item.type === 'custom');
      
      if (CustomData.length > 0) {
        for (var i = 0; i < CustomData.length; i++) {
          var customDetails = CustomData[i].details.fetchingdata;

          if (customDetails.length > 0) {
            for (var j = 0; j < customDetails.length; j++) {
              var api_data = '';
              if (customDetails[j].apiData) {
                api_data = customDetails[j].apiData;
              }

              if (customDetails[j].api === "STATIC") {
                customJson = { ...customJson, [`${CustomData[i].comp_id}_${customDetails[j].id}`]: customDetails[j].value || null };
              } else {
                const res = await Get('', customDetails[j].api, api_data);
                if (res.success) {
                  customJson = { ...customJson, [`${CustomData[i].comp_id}_${customDetails[j].id}`]: res.data };
                }
              }
            }
          }
        }
      }

      setModalCustomData(customJson);
    } catch (error) {
      console.log('Error in fetchCustomData: ', error);
    }
  }

  async function FetchAllModalData() {
    try {
      await fetchModalMainData();
      await fetchFormSelectsData();
      await fetchCustomData();
    } catch (error) {
      console.log('Error in FetchAllModalData (Modal Section): ', error);
    }
  }

  return (
    <button
      style={item?.mainStyle || {}}
      className={` ${!item?.hideDefaultStyle && `p-2 w-[150px] rounded hover:opacity-70 m-1`} ${item.style} `}
      onClick={async () => {
        if (item.action === "modal") {
          if (showModal) {
            setModalData(item);
            await FetchAllModalData();
          } else {
            setModalData(item);
            setShowModal(true);
            await FetchAllModalData();
          }
        }
        setDropDown(-1);
      }}
    >
      {item.label}
    </button>
  );
};